import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { compose } from "recompose";
import { showModal } from "../../../redux/actions";
import ManageSubscriptionModal from "../ManageSubscriptionModal";

const ManageSubscriptionMenuItem = ({ subscriber, onComplete }) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(showModal(ManageSubscriptionModal, { subscriber: subscriber }));
    onComplete();
  };

  return (
    <MenuItem
      onClick={() => {
        onClick();
      }}
    >
      Manage Subscription
    </MenuItem>
  );
};

const enhance = compose(injectIntl);

export default enhance(ManageSubscriptionMenuItem);
